<template>
  <!-- the ticket, in place: the full details page (edit, comments,
       attachments, status, assist export) hosted in a modal so the list
       or board underneath never has to be left. no modal header -- the
       details component's own header (chevron, title, actions) is the
       header, and its chevron closes the modal. the component is keyed
       on the ticket so opening a different one mounts fresh state. -->
  <b-modal :id="modalId" size="xl" hide-header hide-footer scrollable
           dialog-class="stm-dialog" content-class="stm-content" body-class="stm-body"
           @hidden="onHidden">
    <support-ticket-details
      v-if="ticketRef"
      :key="'modal-' + ticketRef.tenant_id + '#' + ticketRef.id"
      :ticket-id="String(ticketRef.id)"
      :tenant-id="ticketRef.tenant_id"
      embedded
      @close="$bvModal.hide(modalId)"
      @showAlert="(msg, variant, ms) => $emit('showAlert', msg, variant, ms)"
    />
  </b-modal>
</template>

<script>
import SupportTicketDetails from './support_ticket_details.vue'

// shared by the Ticket Board and the support ticket list. the host calls
// open({ tenant_id, id }) and listens for `hidden`, which hands the same
// ref back so the host can refetch that one ticket and patch its row.
export default {
  name: 'SupportTicketModal',
  components: { SupportTicketDetails },
  props: {
    // hosts that can both be mounted at once need distinct ids
    modalId: { type: String, default: 'support-ticket-modal' },
  },
  data() {
    return { ticketRef: null }
  },
  methods: {
    open(ref) {
      this.ticketRef = { tenant_id: ref.tenant_id, id: ref.id }
      this.$nextTick(() => this.$bvModal.show(this.modalId))
    },
    close() {
      this.$bvModal.hide(this.modalId)
    },
    onHidden() {
      const ref = this.ticketRef
      this.ticketRef = null
      this.$emit('hidden', ref)
    },
  },
}
</script>

<style>
/* the modal is portaled to <body>, so its classes are global. the dialog
   is as wide as the details page allows (std-root caps at 1400px) and the
   body carries no padding of its own -- std-root's gutters are the
   padding. */
.stm-dialog.modal-xl { max-width: min(1400px, 96vw); margin: 1.5rem auto; }
.stm-body { padding: 0; }
/* std-root's top inset plus the modal's own would double up */
.stm-body .std-root { padding-top: 4px; }
@media (max-width: 720px) {
  .stm-dialog.modal-xl { margin: 0.5rem; max-width: none; }
}
</style>
